import React, { createContext, useContext, useState } from 'react';

const ServiceContext = createContext();

const DEFAULTS = [
  'Web Development','Mobile App','CRM Development','UI/UX Design',
  'Digital Marketing','SEO','Social Media Management','AI Automation',
  'E-commerce','Software Development','Consulting','Other'
];

export function ServiceProvider({ children }) {
  const [services, setServices] = useState(DEFAULTS);
  const add    = (s) => { if(s.trim() && !services.includes(s.trim())) setServices(p=>[...p,s.trim()]); };
  const remove = (s) => setServices(p=>p.filter(x=>x!==s));
  const edit   = (old,nw) => { if(nw.trim()) setServices(p=>p.map(x=>x===old?nw.trim():x)); };
  return <ServiceContext.Provider value={{services,add,remove,edit}}>{children}</ServiceContext.Provider>;
}

export const useServices = () => useContext(ServiceContext);
